import {
  sendSMS,
  scheduleSMS,
  sendGroupSMS,
  scheduleGroupSMS,
  sendCsvSMS,
  scheduleCsvSMS,
} from "@/api/sendService";

export default {
  //Send sms
  async sendSMS({ commit, rootState }, payload) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });
      rootState.loading.sendBtn.load = true;
      rootState.loading.sendBtn.disabled = true;
      await sendSMS(payload);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "SMS sent!",
          color: "success",
        },
        { root: true }
      );
      rootState.loading.sendBtn.load = false;
      rootState.loading.sendBtn.disabled = false;
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.data.error,
          color: "error",
        },
        { root: true }
      );
      rootState.loading.sendBtn.load = false;
      rootState.loading.sendBtn.disabled = false;
    }
  },

  //Schedule sms
  async scheduleSMS({ commit, rootState }, payload) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });
      rootState.loading.scheduleBtn.load = true;
      rootState.loading.scheduleBtn.disabled = true;
      await scheduleSMS(payload);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "SMS scheduled!",
          color: "success",
        },
        { root: true }
      );
      rootState.loading.scheduleBtn.load = false;
      rootState.loading.scheduleBtn.disabled = false;
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.data.error,
          color: "error",
        },
        { root: true }
      );
      rootState.loading.scheduleBtn.load = false;
      rootState.loading.scheduleBtn.disabled = false;
    }
  },

  //Send sms to group(s)
  async sendGroupSMS({ commit, rootState }, payload) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });
      rootState.loading.sendBtn.load = true;
      rootState.loading.sendBtn.disabled = true;
      await sendGroupSMS(payload);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "SMS sent!",
          color: "success",
        },
        { root: true }
      );
      rootState.loading.sendBtn.load = false;
      rootState.loading.sendBtn.disabled = false;
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.data.error,
          color: "error",
        },
        { root: true }
      );
      rootState.loading.sendBtn.load = false;
      rootState.loading.sendBtn.disabled = false;
    }
  },

  //Schedule group sms
  async scheduleGroupSMS({ commit, rootState }, payload) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });
      rootState.loading.scheduleBtn.load = true;
      rootState.loading.scheduleBtn.disabled = true;
      await scheduleGroupSMS(payload);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "SMS scheduled!",
          color: "success",
        },
        { root: true }
      );
      rootState.loading.scheduleBtn.load = false;
      rootState.loading.scheduleBtn.disabled = false;
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.data.error,
          color: "error",
        },
        { root: true }
      );
      rootState.loading.scheduleBtn.load = false;
      rootState.loading.scheduleBtn.disabled = false;
    }
  },

  //Send sms to csv
  async sendCsvSMS({ commit, rootState }, payload) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });
      rootState.loading.sendBtn.load = true;
      rootState.loading.sendBtn.disabled = true;
      await sendCsvSMS(payload);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "SMS sent!",
          color: "success",
        },
        { root: true }
      );
      rootState.loading.sendBtn.load = false;
      rootState.loading.sendBtn.disabled = false;
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.data.error,
          color: "error",
        },
        { root: true }
      );
      rootState.loading.sendBtn.load = false;
      rootState.loading.sendBtn.disabled = false;
    }
  },

  //Schedule CSV sms
  async scheduleCsvSMS({ commit, rootState }, payload) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });
      rootState.loading.scheduleBtn.load = true;
      rootState.loading.scheduleBtn.disabled = true;
      await scheduleCsvSMS(payload);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "SMS scheduled!",
          color: "success",
        },
        { root: true }
      );
      rootState.loading.scheduleBtn.load = false;
      rootState.loading.scheduleBtn.disabled = false;
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.data.error,
          color: "error",
        },
        { root: true }
      );
      rootState.loading.scheduleBtn.load = false;
      rootState.loading.scheduleBtn.disabled = false;
    }
  },
};
